import React from 'react'
import Slider from 'react-slick';
import tune from './../assest/images/projectss/logo/New folder (2)/Deep Tune/Logo.jpg'
import tune1 from './../assest/images/projectss/logo/New folder (2)/Deep Tune/Colors.jpg'
import tune2 from './../assest/images/projectss/logo/New folder (2)/Deep Tune/ID.jpg'
import tune3 from './../assest/images/projectss/logo/New folder (2)/Deep Tune/insta story.jpg'
import tune4 from './../assest/images/projectss/logo/New folder (2)/Deep Tune/mobile icon.jpg'
import tune5 from './../assest/images/projectss/logo/New folder (2)/Deep Tune/mockup 1.jpg'
import tune6 from './../assest/images/projectss/logo/New folder (2)/Deep Tune/Shop Facade Logo MockUp 2.jpg'
import tune7 from './../assest/images/projectss/logo/New folder (2)/Deep Tune/Sketching.jpg'
import v1 from './../assest/images/projectss/logo/New folder (2)/Velibt/Business_Card_Mockup_1.jpg'
import v2 from './../assest/images/projectss/logo/New folder (2)/Velibt/Candle_Mockup_on_Wooden_Crate.jpg'
import v3 from './../assest/images/projectss/logo/New folder (2)/Velibt/Cosmetics Packaging PSD MockUp.jpg'
import v4 from './../assest/images/projectss/logo/New folder (2)/Velibt/Free Bottle Mockup.jpg'
import v5 from './../assest/images/projectss/logo/New folder (2)/Velibt/Hanging Wall Sign MockUp.jpg'
import v6 from './../assest/images/projectss/logo/New folder (2)/Velibt/Rectangle_Eye_Shadow_Mockup.jpg'
import v7 from './../assest/images/projectss/logo/New folder (2)/Velibt/Rectangle_Eye_Shadow_Mockup.jpg'
import v8 from './../assest/images/projectss/logo/New folder (2)/Velibt/Rectangle_Eyeshadow_Mockup.jpg'
import v9 from './../assest/images/projectss/logo/New folder (2)/Velibt/Shopping_Bag_Close-up.jpg'
import v10 from './../assest/images/projectss/logo/New folder (2)/Velibt/Square_Sign_Mockup.jpg'
import v11 from './../assest/images/projectss/logo/New folder (2)/Velibt/Untitled-1.jpg'
import a1 from './../assest/images/projectss/logo/New folder (2)/النشمي/1.jpg'
import a2 from './../assest/images/projectss/logo/New folder (2)/النشمي/2.jpg'
import a3 from './../assest/images/projectss/logo/New folder (2)/النشمي/3.jpg'
import a4 from './../assest/images/projectss/logo/New folder (2)/النشمي/4.jpg'
import a5 from './../assest/images/projectss/logo/New folder (2)/النشمي/5.jpg'
import a6 from './../assest/images/projectss/logo/New folder (2)/النشمي/6.jpg'
import a7 from './../assest/images/projectss/logo/New folder (2)/النشمي/7.jpg'
import a8 from './../assest/images/projectss/logo/New folder (2)/النشمي/8.jpg'
import a9 from './../assest/images/projectss/logo/New folder (2)/النشمي/9.jpg'
import a10 from './../assest/images/projectss/logo/New folder (2)/النشمي/10.jpg'
import a11 from './../assest/images/projectss/logo/New folder (2)/النشمي/11.jpg'
import va1 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/1- logo design.jpg'
import va2 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/2-logo.jpg'
import va3 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/business card.jpg'
import va4 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/colors.jpg'
import va5 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/logo design 2.jpg'
import va6 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/mackbook.jpg'
import va7 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/Poster Artwork in a Modern Loft MockUp.jpg'
import va8 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/Shop Facade Logo MockUp 2.jpg'
import va9 from './../assest/images/projectss/logo/New folder (2)/VocalAtmos/street.jpg'
import w1 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/1.jpg'
import w2 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/10.jpg'
import w3 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/11.jpg'
import w4 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/2-1.jpg'
import w5 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/2.jpg'
import w6 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/3.jpg'
import w7 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/4-1.jpg'
import w8 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/4-2.jpg'
import w9 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/4-3.jpg'
import w10 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/4-4.jpg'
import w11 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/4.jpg'
import w12 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/5.jpg'
import w13 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/8.jpg'
import w14 from './../assest/images/projectss/logo/New folder (2)/MB WATCHES/watches/MB WATCH BROCHOUR.jpg'
import './../assest/style/Swiper.css'
export const Swiperr = () => {

  
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      }
    ]
  };

  
  const ldata = [
    {
     
    
cover:tune
 },
 {
     
    
 cover:tune1
 },
 {
     
    
cover:tune2
 },
 {
     
    
 cover:tune3
  },
 {
     
    
    cover:tune4
 },
  {
     

  cover:tune5
        },
 {
     
 cover:tune6
        },
            
        {
     
          cover:tune7
                 },

  ]
  const vdata=[
    {
      cover:v1
    },
    {
      cover:v2
    },
    {
      cover:v3
    },
    {
      cover:v4
    },
    {
      cover:v5
    },
    {
      cover:v6
    },
    {
      cover:v7
    },
    {
      cover:v8
    },
    {
      cover:v9
    },
    {
      cover:v10
    },
    {
      cover:v11
    }
  ]
  const adata=[
  {
    cover:a1
  },
  {
    cover:a2
  },
  {
    cover:a3
  },
  {
    cover:a4
  },
  {
    cover:a5
  },
  {
    cover:a6
  },
  {
    cover:a7
  },
  {
    cover:a8
  },
  {
    cover:a9
  },
  {
    cover:a10
  },
  {
    cover:a11
  },
  ]
  const vadata=[
    {
      cover:va1
    },
    {
      cover:va2
    },
    {
      cover:va3
    },
    {
      cover:va4
    },
    {
      cover:va5
    },
    {
      cover:va6
    },
    {
      cover:va7
    },
    {
      cover:va8
    },
    {
      cover:va9
    },
  ]
  const wdata=[
    {
      cover:w1
    },
    {
      cover:w2
    },
    {
      cover:w3
    },
    {
      cover:w4
    },
    {
      cover:w5
    },
    {
      cover:w6
    },
    {
      cover:w7
    },
    {
      cover:w8
    },
    {
      cover:w9
    },
    {
      cover:w10
    },
    {
      cover:w11
    },
    {
      cover:w12
    },
    {
      cover:w13
    },
    {
      cover:w14
    },
  ]
  return (
    <div className='swip'>
    <div className='row'>
<div className="container">
<h1>Deep Tune</h1>
<Slider {...settings}>
{ldata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        

<div className='imag ima'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
      
    </div>
    </div>
{/*  */}


<div className='row'>
<div className="container">
  <h1>Velbit</h1>
<Slider {...settings}>
{vdata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        

<div className='imag ima'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
      
    </div>
    </div>

    {/*  */}
    <div className='row'>
<div className="container">
  <h1>Alnashmy</h1>
<Slider {...settings}>
{adata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        

<div className='imag ima'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
      
    </div>
    </div>



    {/*  */}

    <div className='row'>
<div className="container">
  <h1>Vocal Atoms</h1>
<Slider {...settings}>
{vadata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        

<div className='imag ima'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
      
    </div>
    </div>


    {/*  */}

    <div className='row'>
<div className="container">
  <h1>Watch</h1>
<Slider {...settings}>
{wdata.map((value,index)=>{
    return(
        <div className='in d-flex' key={index}>
        

<div className='imag ima'>
<img src={value.cover}/>
</div>

</div>

    )
})}
</Slider>
      
    </div>
    </div>


    {/*  */}

    
    </div>
    
  )
}
